import React, { Component, Fragment } from 'react';

class Carousel extends Component {
  state = {
    image: '',
    counter: 0,
    dots: [],
    style: true
  };

  componentDidMount() {
    this.imageSlider();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  imageSlider = () => {
    const { image, counter } = this.state;
    const { imageList } = this.props;
    let newImage;
    if (imageList.length === 1) {
      this.setState({ image: imageList[0] });
    } else {
      if (counter <= imageList.length) {
        if (!image) {
          let arr1 = [];
          this.setState({
            image: imageList[0],
            counter: this.state.counter + 1
          });
          for (let i = 0; i < imageList.length; i++) {
            if (i === 0) {
              arr1.push(<div className="circle cir1" />);
            } else {
              arr1.push(<div className="circle cir2" />);
            }
          }
          this.setState({ dots: arr1 });
        }

        this.timer = setInterval(() => {
          let arr = [];
          newImage = imageList[this.state.counter];
          if (this.state.counter !== imageList.length) {
            this.setState((prevState, props) => ({
              image: newImage,
              style: !prevState.style,
              counter: prevState.counter + 1
            }));
          }
          if (this.state.counter === imageList.length) {
            this.setState({ counter: 0 });
          }
          for (let i = 0; i < imageList.length; i++) {
            if (
              (this.state.counter === 0 && imageList.length - 1 === i) ||
              i === this.state.counter - 1
            ) {
              arr.push(<div className="circle cir1" />);
            } else {
              arr.push(<div className="circle cir2" />);
            }
          }
          this.setState({ dots: arr, counter: this.state.counter });
        }, 4500);
      }
    }
  };

  arrowClick = e => {
    const { counter } = this.state;
    const { imageList } = this.props;
    let num = counter;

    if (e === 'left' && counter > 0) {
      if (counter === 1) {
        this.setState((prevState, props) => ({
          image: props.imageList[props.imageList.length - 1],
          counter: imageList.length
        }));
        num = imageList.length;
      } else if (counter === 0) {
        this.setState((prevState, props) => ({
          image: props.imageList[props.imageList.length - 2],
          counter: prevState.counter - 1
        }));
        num = imageList.length - 1;
      } else {
        this.setState((prevState, props) => ({
          image: props.imageList[prevState.counter - 2],
          counter: prevState.counter - 1
        }));
        num -= 1;
      }
    } else {
      if (counter === 0) {
        this.setState((prevState, props) => ({
          image: props.imageList[0],
          counter: 1
        }));
        num = 1;
      } else if (counter === this.props.imageList.length) {
        this.setState((prevState, props) => ({
          image: props.imageList[0],
          counter: 1
        }));
        num = 1;
      } else {
        this.setState((prevState, props) => ({
          image: props.imageList[prevState.counter],
          counter: prevState.counter + 1
        }));
        num += 1;
      }
    }
    let arr = [];

    for (let i = 0; i < imageList.length; i++) {
      if (i === num - 1 || (num === 0 && imageList.length === i)) {
        arr.push(<div className="circle cir1" />);
      } else {
        arr.push(<div className="circle cir2" />);
      }
    }
    this.setState({ dots: arr });

   clearInterval(this.timer);
    this.imageSlider()
  };

  render() {
    const { style, dots } = this.state;

    const dotMap = dots.map((e, i) => {
      return <div key={i}>{e}</div>;
    });
    return (
      <div className="carousel">
        <p>{this.state.image.school}</p>
        <img
          className={style ? 'image_scroll' : 'image_scroll2'}
          src={this.state.image.img}
          alt="Carousel"
        />
        {this.props.imageList.length > 1 && (
          <Fragment>
            <svg
              className="arrow arrow1"
              onClick={()=>this.arrowClick('left')}
              viewBox="0 0 129 129"
              enableBackground="new 0 0 129 129"
            >
              <g>
                <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z" />
              </g>
            </svg>

            <svg
              className="arrow arrow2"
              onClick={()=>this.arrowClick('right')}
              viewBox="0 0 129 129"
              enableBackground="new 0 0 129 129"
            >
              <g>
                <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z" />
              </g>
            </svg>
          </Fragment>
        )}
        <div className="dotMap">{dotMap}</div>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/Components/Tools/Carousel.js